import {centsToDollarDisplay} from '~/common/utils/payment_utils';
import {Typography} from '~library/atoms/Typography';

import './GiftCard.sass';

export const GiftCard = ({guestsQuantity, giftCard, fullWidth = false, className}) => (
  <div className={`gift-card-card ${fullWidth ? 'full-width' : ''} ${className}`}>
    <div className="gift-card-card__info">
      <img className="gift-card-card__info__image" src={giftCard?.image} alt="gift card" />
      <Typography variant="paragraph2" color="charcoal">
        {giftCard?.product_config_name} {guestsQuantity > 1 && `(${guestsQuantity}x)`}
      </Typography>
    </div>

    <Typography variant="paragraph2" color="charcoal">
      {centsToDollarDisplay(giftCard?.amount_in_cents, true, true)}
    </Typography>
  </div>
);
